module.exports = __webpack_public_path__ + "img/about-advantage2.b66b8c54.png";